<template>

  <list-container :name="name">

    <list-nav>
      <list-nav-header title="Document Acknowledgements" searchable="true"></list-nav-header>


      <filter-bar :filters="filters" class="hidden-mobile"></filter-bar>

      <list-nav-scroll>

        <ul class="hidden-desktop mobile-list-view">
          <li v-for="item in items">
            <a href="#" @click.prevent="false" class="info">
              <span>{{ item.name }}</span>
              <span>{{ item.version }}</span>
              <span>{{ item.title }}</span>
              <span>{{ item.acknowledged ? "Acknowledged" : "Waiting" }}</span>
            </a>
          </li>
        </ul>

        <table class="responsive-table fix-head hidden-mobile">
          <thead>
          <tr>
            <th scope="col">Name</th>
            <th scope="col">Title</th>
            <th scope="col">Version</th>
            <th scope="col">Acknowledged</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="item in items">
            <td scope="row" data-label="Name">{{ item.name }}</td>
            <td scope="row" data-label="Title">{{ item.title }}</td>
            <td scope="row" data-label="Version">{{ item.version }}</td>
            <td scope="row" data-label="Acknowledged">{{ item.acknowledged ? "Acknowledged at "+ item.acknowledged_at : 'Waiting'}}</td>
          </tr>
          </tbody>
        </table>


      </list-nav-scroll>
    </list-nav>

  </list-container>
</template>

<script>

export default {
  props: ['compact'],
  data() {
    return {
      name: 'acknowledgments-list',
      items: [],
      filtered: null,
    }
  },
  filters: {

  },
  watch: {
    filtered: function(){
      this.getItems();
    }
  },
  computed: {
    is_filtered(){
      if(this.filtered === false)
      {
        return false;
      }

      return true;
    },
    view_all() {
      if (this.compact === true || this.compact == 'true') {
        return false;
      }

      return true;
    },
    filters: function(){
      return {acknowledged: 'Acknowledged', waiting: 'Awaiting Acknowledgement'};
    }
  },
  methods: {
    getItems() {
      var that = this;
      var url = appUrls.acknowledgements.index;
      var params = {};

      var hasGetVariable = location.search.indexOf('filter=') >= 0;
      if (hasGetVariable) {
        window.eventBus.$emit('filter-bar-changed',getParameterByName('filter'),this.filters[getParameterByName('filter')]);
        this.filtered = getParameterByName('filter');
      }

      if (this.is_filtered) {
        params.filter = this.filtered;
      }

      that.items = [];

      axios.get(url, {params: params})
          .then(response => {
            that.items = response.data.data;
          });
    }
  },
  mounted() {
    var that = this;

    this.getItems();


    window.eventBus.$on('filter-bar-changed',function(value){
      that.filtered = value;
    });

  }
}
</script>

<style lang="scss">

</style>
